// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Types_CrossSellingKind from "../Restaumatic.Analytics.Types.CrossSellingKind/index.js";
import * as Restaumatic_Analytics_Types_CrossSellingPlace from "../Restaumatic.Analytics.Types.CrossSellingPlace/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Analytics_Types_CrossSellingKind.eqCrossSellingKind));
var eq1 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Analytics_Types_CrossSellingPlace.eqCrossSellingPlace);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var MenuIsSymbol = {
    reflectSymbol: function () {
        return "Menu";
    }
};
var kindIsSymbol = {
    reflectSymbol: function () {
        return "kind";
    }
};
var placeIsSymbol = {
    reflectSymbol: function () {
        return "place";
    }
};
var CrossSellingIsSymbol = {
    reflectSymbol: function () {
        return "CrossSelling";
    }
};
var LastOrderIsSymbol = {
    reflectSymbol: function () {
        return "LastOrder";
    }
};
var genericDecodeSumConstruct1 = /* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume);
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var Menu = /* #__PURE__ */ (function () {
    function Menu() {

    };
    Menu.value = new Menu();
    return Menu;
})();
var CrossSelling = /* #__PURE__ */ (function () {
    function CrossSelling(value0) {
        this.value0 = value0;
    };
    CrossSelling.create = function (value0) {
        return new CrossSelling(value0);
    };
    return CrossSelling;
})();
var LastOrder = /* #__PURE__ */ (function () {
    function LastOrder() {

    };
    LastOrder.value = new LastOrder();
    return LastOrder;
})();
var toFillFormTypeItemList = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var eqItemList = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Menu && y instanceof Menu) {
                return true;
            };
            if (x instanceof CrossSelling && y instanceof CrossSelling) {
                return eq(x.value0.kind)(y.value0.kind) && eq1(x.value0.place)(y.value0.place);
            };
            if (x instanceof LastOrder && y instanceof LastOrder) {
                return true;
            };
            return false;
        };
    }
};
var genericItemList = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Menu.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new CrossSelling(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return LastOrder.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Types.ItemList (line 17, column 1 - line 17, column 71): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Menu) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof CrossSelling) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof LastOrder) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Types.ItemList (line 17, column 1 - line 17, column 71): " + [ x.constructor.name ]);
    }
};
var showItemList = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericItemList)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(MenuIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(kindIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(placeIsSymbol)(Restaumatic_Analytics_Types_CrossSellingPlace.showCrossSellingPlace))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Analytics_Types_CrossSellingKind.showCrossSellingKind)))))(CrossSellingIsSymbol))(/* #__PURE__ */ genericShowConstructor(LastOrderIsSymbol))))
};
var unscrambleDecodeItemList = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericItemList)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(MenuIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(CrossSellingIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons(kindIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Analytics_Types_CrossSellingKind.unscrambleDecodeCrossSellingKind))(/* #__PURE__ */ Unscramble.decodeRecordCons(placeIsSymbol)(Restaumatic_Analytics_Types_CrossSellingPlace.unscrambleDecodeCrossSellingPlace)(Unscramble.decodeRecordNil)))))(/* #__PURE__ */ genericDecodeSumConstruct1(LastOrderIsSymbol)))))(Unscramble_Generic.defaultOptions)
};
var encodeItemList = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericItemList)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(MenuIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CrossSellingIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(placeIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Analytics_Types_CrossSellingPlace.encodeCrossSellingPlace)))(kindIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Analytics_Types_CrossSellingKind.encodeCrossSellingKind)))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(LastOrderIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))))
};
var decodeItemList = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericItemList)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(MenuIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CrossSellingIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(placeIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Analytics_Types_CrossSellingPlace.decodeCrossSellingPlace))())(kindIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Analytics_Types_CrossSellingKind.decodeCrossSellingKind)))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(LastOrderIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))))
};
export {
    Menu,
    CrossSelling,
    LastOrder,
    genericItemList,
    eqItemList,
    showItemList,
    encodeItemList,
    decodeItemList,
    unscrambleDecodeItemList,
    toFillFormTypeItemList
};
